export const COVER_SETTINGS_UPDATE_LOGO =
  'REPORTING_COVER_SETTINGS_UPDATE_LOGO';

export const updateLogo = base64String => ({
  type: COVER_SETTINGS_UPDATE_LOGO,
  base64String,
});
